export const state = () => ({
    modal: {
        show: false,
        component: null,
        props: null,
        style: 'default',
        size: null,
    },
    isInWidgetConfigMode: false,
    isUpdatingWidgets: false,
    loader: null,
});

export const mutations = {
    showLoader(state, loader) {
        state.loader = loader;
    },
    hideLoader(state) {
        state.loader = null;
    },
    showModal(state, payload) {
        state.modal.show = true;
        state.modal.component = payload.component;
        state.modal.props = payload.props;
        state.modal.style = payload.style || 'default';
        state.modal.size = payload.size || null;
    },
    hideModal(state) {
        state.modal.show = false;
        state.modal.component = null;
    },
    toggleWidgetConfigMode(state, payload = null) {
        state.isInWidgetConfigMode = payload === null ? !state.isInWidgetConfigMode : payload;
    },
    setIsUpdatingWidgets(state, payload) {
        state.isUpdatingWidgets = payload;
    },
    resetUI(state) {
        state.modal = {
            show: false,
            component: null,
            props: null,
            style: 'default',
        };
        state.loader = null;
        state.isInWidgetConfigMode = false;
    },
};

export const getters = {
    getIsShowingModalByComponent: (state) => (component) => {
        return state.modal && state.modal.component === component ? state.modal.show : false;
    },
    isUpdatingWidgets(state) {
        return state.isUpdatingWidgets;
    },
    isInWidgetConfigMode(state) {
        return state.isInWidgetConfigMode;
    },
    getModal(state) {
        return state.modal;
    },
    getLoader(state) {
        return state.loader;
    },
};
